import { Injectable } from '@angular/core';
import { Chat } from '../models/chat';
import { searchProduct } from '../models/search-product';
import { additionalInfo, Product } from '../models/response';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { storeInventory } from '../models/inventory';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  // api url key
  url:string = environment.apiUrl;
    
  selectedProducts:Product[] = [];

  constructor(private http:HttpClient) { }

  getSelectedProducts(messages: Chat[]) {
    this.selectedProducts = [];
    messages.forEach((data) => {
      if (data.products.length > 0) {
        data.products.forEach((product: searchProduct) => {
          if (product.selected) {
            this.selectedProducts.push(product.product);
          }
        });
      }
    });
    return this.selectedProducts;
  }

  getProducts(searchProducts: searchProduct[]){
    const products:Product[] = [];
    searchProducts.forEach((data) => {
      if(data.selected){
        products.push(data.product);
      }
    });
    return products;
  }

  resetProducts(messages:Chat[]){
    return messages.map((chat:Chat) => {
      if(chat.products.length !==  0){
        chat.products = chat.products.map((product:searchProduct) => {
          product.selected = false;
          return product;
        })
      }
      return chat;
    })
  }

  getStoreInventory(productIds:string[], store: string, storeId:string):Observable<additionalInfo[]>{
    const body:storeInventory = {
      apiName: "product_store_inventory",
      store: store,
      storeId: storeId,
      skus: productIds
    };
    return this.http.post<additionalInfo[]>(`${this.url}/ask-scotty/product-store-inventory`,body);
  }
}
